export enum Configuration {
  RENEWAL_WINDOW = "RENEWAL_WINDOW",
  ELECTRICITY_VAT_CHANGE_FROM = "ELECTRICITY_VAT_CHANGE_FROM",
  ELECTRICITY_VAT_CHANGE_NEW_RATE = "ELECTRICITY_VAT_CHANGE_NEW_RATE",
}
